import { createBrowserRouter, Navigate } from "react-router-dom";

import { RequireAuth } from "./auth/RequireAuth";
import { ApiDocsPage } from "./routes/ApiDocsPage";
import { BestellungDetailPage } from "./routes/BestellungDetailPage";
import { BestellungenPage } from "./routes/BestellungenPage";
import { HerstellerDetailPage } from "./routes/HerstellerDetailPage";
import { HerstellerPage } from "./routes/HerstellerPage";
import { StoffDetailPage } from "./routes/StoffDetailPage";
import { StoffePage } from "./routes/StoffePage";
import { StoffWertePage } from "./routes/StoffWertePage";
import { KalkulationPage } from "./routes/KalkulationPage";
import { KonfiguratorPage } from "./routes/KonfiguratorPage";
import { MontageeditorPage } from "./routes/MontageeditorPage";
import { AppLayout } from "./routes/AppLayout";
import { LoginPage } from "./routes/LoginPage";
import { NotFoundPage } from "./routes/NotFoundPage";
import { ObjektDetailPage } from "./routes/ObjektDetailPage";
import { ObjektePage } from "./routes/ObjektePage";
import { TenantDetailPage } from "./routes/TenantDetailPage";
import { TenantsPage } from "./routes/TenantsPage";

// Alles außer /login liegt hinter RequireAuth.
export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          { index: true, element: <TenantsPage /> },
          { path: "tenants/:id", element: <TenantDetailPage /> },
          { path: "konfigurator", element: <KonfiguratorPage /> },
          { path: "bestellungen", element: <BestellungenPage /> },
          { path: "objekte", element: <ObjektePage /> },
          { path: "objekte/:id", element: <ObjektDetailPage /> },
          { path: "bestellungen/:id", element: <BestellungDetailPage /> },
          { path: "hersteller", element: <HerstellerPage /> },
          { path: "hersteller/:schluessel", element: <HerstellerDetailPage /> },
          { path: "montageeditor", element: <MontageeditorPage /> },
          { path: "montage", element: <Navigate to="/montageeditor" replace /> },
          { path: "kalkulation", element: <KalkulationPage /> },
          { path: "stoffe", element: <StoffePage /> },
          // Feste Pfade vor stoffe/:id – sonst landeten sie als Id im Formular.
          { path: "stoffe/neu", element: <StoffDetailPage /> },
          { path: "stoffe/typen", element: <StoffWertePage key="typ" art="typ" /> },
          { path: "stoffe/materialien", element: <StoffWertePage key="material" art="material" /> },
          { path: "stoffe/:id", element: <StoffDetailPage /> },
          { path: "api-docs", element: <ApiDocsPage /> },
          { path: "*", element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
